import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    OnInit,
    Output,
    EventEmitter,
    ViewChild,
  } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDradDropDirective } from '../../directives/ngx-dragdrop.directive';
  import { DatalistActionItem } from "../../models/datalist-action-item.interface";
  import { Router } from "@angular/router";
  import { DatatableComponent, NgxDatatableModule, SortDirection } from "@swimlane/ngx-datatable";

  @Component({
    imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      MatInput,
      NgxDatatableModule,
      NgxDradDropDirective,
      TranslateModule
    ],
    selector: "app-draggable-table-regulations",
    standalone: true,
    styleUrls: ["./draggable-table-regulations.component.scss"],
    templateUrl: "./draggable-table-regulations.component.html"
  })
  export class DraggableTableRegulationsComponent implements OnInit {
    rows: any[] = [];
    public columnList: any[] = [];
    actionItems: DatalistActionItem[];
    loadingIndicator = true;
    isEditable: any = {};
    editingItemCount = 0;
    editedItemOriginalData: any[] = [];
    showTable: boolean = true;
    @ViewChild("datatable")
    public datatable: DatatableComponent;
    @Input()
    columns: any[];
    @Input() data: [];
    @Input() sorts: any;
    @Input() actions: DatalistActionItem[];
    @Output() callbackOnDrop: EventEmitter<any> = new EventEmitter<any>();
    @Output() callbackOnUpdate: EventEmitter<any> = new EventEmitter<any>();
    @Output() callbackEmit = new EventEmitter();
    @Output() sortEvent = new EventEmitter();

    constructor(public router: Router) {}

    loaderVisibility(value: boolean) {
      this.loadingIndicator = value;
    }


    reset() {
      this.showTable = false;
      setTimeout(() => {
        this.showTable = true;
      });
    }

    onColumnSort(a: any) {
      //console.log(a);
      if (!a.sorts || !a.sorts.length) {
        return;
      }
      a.sorts.forEach((b: any): void => {
        if (b.dir.toLowerCase() === "asc") {
          b.dir = SortDirection.asc;
        } else {
          b.dir = SortDirection.desc;
        }
      });
      if (!this.datatable) {
        return;
      }
      this.datatable.onColumnSort(a);
    }

    onEdit(index: number): void {
      // @ts-ignore
      this.isEditable[index] = true;
      this.editingItemCount++;
      this.editedItemOriginalData[index] = { ...this.rows[index] };
    }

    onCancelEdit(index: number): void {
      // @ts-ignore
      this.isEditable[index] = false;
      this.editingItemCount--;
      this.rows[index] = this.editedItemOriginalData[index];
      this.rows = [...this.rows];
    }

    onSort(event: any) {
      this.sortEvent.emit(event);
    }

    updateRows(data: any) {
      this.rows = data;
    }

    onDrop(event: any) {
      //this.rows = event;
      this.callbackOnDrop.emit(event);
    }

    ngOnInit() {
      this.rows = this.data;
      this.columnList = this.columns;
      this.actionItems = this.actions;
    }

    onActionClick(item: DatalistActionItem, id: any) {
      if (item.route) {
        this.router.navigate([item.route]);
      } else if (item.callback) {
        this.callbackEmit.emit(item.callback(id));
      }
    }

    saveData(row: any, rowIndex: any) {
      this.callbackOnUpdate.emit(row);
      // @ts-ignore
      this.isEditable[rowIndex] = false;
    }
  }
